/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.free} free transfers used`)
};

const es_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} de ${i?.free} traspasos gratuitos usados`)
};

const de_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} von ${i?.free} freien Transfers genutzt`)
};

const nl_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} van ${i?.free} gratis transfers gebruikt`)
};

const fr_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} des ${i?.free} transferts gratuits utilisés`)
};

const it_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} di ${i?.free} trasferimenti gratuiti usati`)
};

const pt_br2_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} de ${i?.free} transferências grátis usadas`)
};

const pt_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} de ${i?.free} transferências grátis usadas`)
};

const ja_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料移籍 ${i?.free} 回中 ${i?.used} 回使用`)
};

const zh_f1_myteam_transfers_status = /** @type {(inputs: { used: NonNullable<unknown>, free: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已使用 ${i?.used}/${i?.free} 次免费转会`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ used: NonNullable<unknown>, free: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_transfers_status = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_transfers_status(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_transfers_status", locale)
	if (locale === "en") return en_f1_myteam_transfers_status(inputs)
	if (locale === "es") return es_f1_myteam_transfers_status(inputs)
	if (locale === "de") return de_f1_myteam_transfers_status(inputs)
	if (locale === "nl") return nl_f1_myteam_transfers_status(inputs)
	if (locale === "fr") return fr_f1_myteam_transfers_status(inputs)
	if (locale === "it") return it_f1_myteam_transfers_status(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_transfers_status(inputs)
	if (locale === "pt") return pt_f1_myteam_transfers_status(inputs)
	if (locale === "ja") return ja_f1_myteam_transfers_status(inputs)
	return zh_f1_myteam_transfers_status(inputs)
};